// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Phone } from '@phosphor-icons/react/dist/ssr/Phone';
import { COLORS } from '../../../styles/UISystem';

/**
 * IconPhone Component
 *
 * Phone icon with different states (default, active, selected)
 */
export const IconPhone = ({ state = 'default', size = 28, color, ...props }) => {
  // Determine background color based on state
  const getBackgroundColor = () => {
    switch (state) {
      case 'active':
        return COLORS.LIGHT_GRAY;
      case 'selected':
        return COLORS.MEDIUM_DARK_GRAY;
      default:
        return 'transparent';
    }
  };

  // Use provided color or default to DARK_GRAY
  const iconColor = color || COLORS.DARK_GRAY;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        backgroundColor: getBackgroundColor(),
        ...props.style,
      }}
      {...props}
    >
      <Phone size={size} color={iconColor} weight="regular" />
    </div>
  );
};

/**
 * IconPhoneExample Component
 *
 * Used for displaying IconPhone examples in the UI System
 */
export const IconPhoneExample = () => {
  return (
    <div style={{ marginBottom: '40px' }}>
      <div
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: COLORS.DARK_GRAY,
          marginBottom: '32px',
          textAlign: 'center',
        }}
      >
        IconPhone
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '16px',
          maxWidth: '500px',
          margin: '0 auto',
        }}
      >
        {/* Default state */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '8px', fontSize: '16px', color: COLORS.DARK_GRAY }}>
            default
          </div>
          <IconPhone state="default" />
        </div>

        {/* Active state */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '8px', fontSize: '16px', color: COLORS.DARK_GRAY }}>
            active
          </div>
          <IconPhone state="active" />
        </div>

        {/* Selected state */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '8px', fontSize: '16px', color: COLORS.DARK_GRAY }}>
            selected
          </div>
          <IconPhone state="selected" />
        </div>
      </div>
    </div>
  );
};

export default IconPhone;
